import { FaHome, FaInstagram, FaLinkedin, FaMailBulk, FaMedium, FaPhone, FaTwitter } from "react-icons/fa";
import "./Footerstyle.css";
import React from 'react';

const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-container">
                <div className="left">
                    <div className="location">
                    <FaHome size={20} style={{color:"#fff",marginRight:"2rem"}}/>
                    <div>
                          <p>Villivakkam, Chennai.</p>
                    </div>
                    </div>
                    <div className="phone">
                    <h4><FaPhone size={20} style={{color:"#fff",marginRight:"2rem"}}/><a href="tel:+91-8925268422">+91-8925268422</a></h4>
                    </div>
                    <div className="email">
                    <h4><FaMailBulk size={20} style={{color:"#fff",marginRight:"2rem"}}/><a href="mailto:knoratecsolutions@gmail.com">knoratecsolutions@gmail.com</a></h4>
                    </div>
                </div>
                <div className="middle">
                    <div className="map">
                    <iframe
    title="Map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.8510885406736!2d80.20353417536325!3d13.108618487219497!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265156b12cb2b%3A0xcacd935c3a468302!2sKnora%20Tec!5e0!3m2!1sen!2sin!4v1691596828447!5m2!1sen!2sin"
    width="100%"
    height="300"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
></iframe>
                    </div>
                </div>
                <div className="right">
                    <div className="social">
                        <h4>Social Handles</h4>
                        <a href="https://www.linkedin.com/company/knora-tec/">
                            <h4><FaLinkedin size={20} style={{color:"#fff",marginRight:"2rem"}}/>Knora Tec</h4>
                        </a>
                        {/* Add other social icons here */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;



// import { FaHome, FaInstagram, FaLinkedin, FaMailBulk, FaMedium, FaPhone, FaTwitter } from "react-icons/fa";
// import "./Footerstyle.css";
// import React from 'react';

// const Footer = () => {
//     return (
//         <div className="footer">
//             <div className="footer-container">
//                 <div className="left">
//                     <div className="location">
//                         <FaHome size={20} style={{color:"#fff",marginRight:"2rem"}}/>
//                         <div>
//                             <p>Villivakkam, Chennai.</p>
//                         </div>
//                     </div>
//                     <div className="phone">
//                         <h4><FaPhone size={20} style={{color:"#fff",marginRight:"2rem"}}/><a href="tel:+91-8925268422">+91-8925268422</a></h4>
//                     </div>
//                     <div className="email">
//                         <h4><FaMailBulk size={20} style={{color:"#fff",marginRight:"2rem"}}/><a href="mailto:knoratecsolutions@gmail.com">knoratecsolutions@gmail.com</a></h4>
//                         <p>&copy; 2023 KNORA Tec. All rights reserved.</p>
//                     </div>
//                 </div>
//                 <div className="right">
//                     <div className="social">
//                         <h4>Social Handles</h4>
//                         <a href="https://www.linkedin.com/company/knora-tec/">
//                             <h4><FaLinkedin size={20} style={{color:"#fff",marginRight:"2rem"}}/>Knora Tec</h4>
//                         </a>
//                         {/* <h4><FaMedium size={20} style={{color:"#fff",marginRight:"2rem"}}/>bluesmeter</h4> */}
//                     </div>
//                 </div>
//                 <div className="map">
//                 {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.8510885406736!2d80.20353417536325!3d13.108618487219497!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265156b12cb2b%3A0xcacd935c3a468302!2sKnora%20Tec!5e0!3m2!1sen!2sin!4v1691596828447!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
//                 <iframe
//     title="Map"
//     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.8510885406736!2d80.20353417536325!3d13.108618487219497!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265156b12cb2b%3A0xcacd935c3a468302!2sKnora%20Tec!5e0!3m2!1sen!2sin!4v1691596828447!5m2!1sen!2sin"
//     width="100%"
//     height="400"
//     style={{ border: 0 }}
//     allowFullScreen=""
//     loading="lazy"
// ></iframe>

//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Footer;
// //https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.8510885406736!2d80.20353417536325!3d13.108618487219497!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265156b12cb2b%3A0xcacd935c3a468302!2sKnora%20Tec!5e0!3m2!1sen!2sin!4v1691596828447!5m2!1sen!2sin
